import { AfterContentInit, EventEmitter, OnInit, TemplateRef } from '@angular/core';
var AbstractDwFormItemComponent = /** @class */ (function () {
    function AbstractDwFormItemComponent(_fg, _translateService) {
        var _this = this;
        this._fg = _fg;
        this._translateService = _translateService;
        /* 是否Flex布局  */
        this.dwFlex = false;
        this.dwRequired = false;
        this._composing = false;
        this.isDisabled = false;
        this.onChange = function (value) { _this.dwValue = value; };
        this.onTouched = function () { };
        this.dwValueChange = new EventEmitter();
        this.controlContainer = _fg;
    }
    AbstractDwFormItemComponent.prototype.compositionStart = function (e) {
        this._composing = true;
    };
    AbstractDwFormItemComponent.prototype.compositionEnd = function (e) {
        this._composing = false;
        this.onChange(this._value);
    };
    Object.defineProperty(AbstractDwFormItemComponent.prototype, "validationMessages", {
        get: function () {
            // console.log('get validationMessages!', this._validationMessages);
            return this._validationMessages;
        },
        set: function (value) {
            this._validationMessages = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractDwFormItemComponent.prototype, "dwValue", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            if ((this._value === value) || ((this._value == null) && (value == null))) {
                return;
            }
            this._value = value;
            if (!this._composing) {
                this.onChange(value);
                this.dwValueChange.emit(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    AbstractDwFormItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._form = this._getForm();
        if (this._form && this.formControlName) {
            this.control = this._form.get(this.formControlName);
            this.control.statusChanges.subscribe(function (data) { return _this.updateValidateStatus(data); });
        }
        this.onInit();
    };
    AbstractDwFormItemComponent.prototype.ngAfterContentInit = function () {
        this.afterContentInit();
    };
    AbstractDwFormItemComponent.prototype.updateValidateStatus = function (status) {
        this.validateStatus = status;
        var errorKeys = [];
        var errors = this.control.errors;
        /* tslint:disable-next-line: forin */
        for (var key in errors) {
            var custMsgs = this.customMessages ? this.customMessages[key] : null;
            var msg = null;
            var error = errors[key];
            if (this._translateService) {
                msg = this._translateService.interpolate(custMsgs, error);
            }
            errorKeys.push({
                key: key,
                params: error,
                message: msg
            });
        }
        this.validationMessages = errorKeys;
    };
    AbstractDwFormItemComponent.prototype._getForm = function () {
        return this.controlContainer ? this.controlContainer.formDirective ?
            this.controlContainer.formDirective.form : null : null;
    };
    AbstractDwFormItemComponent.prototype.getControl = function (name) {
        return this._form ? this._form.get(name) : null;
    };
    AbstractDwFormItemComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    AbstractDwFormItemComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    AbstractDwFormItemComponent.prototype.setDisabledState = function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    AbstractDwFormItemComponent.prototype.writeValue = function (value) {
        this.dwValue = value;
        this.onChange(value);
    };
    return AbstractDwFormItemComponent;
}());
export { AbstractDwFormItemComponent };
